import { apiInstance3 } from 'utils/request'
import parseError from 'helpers/parseServerError'

export const getGptPrompts = () =>
  apiInstance3
    .get('/backoffice/gpt_prompts')
    .catch((error) => {
      parseError(error, 'Cannot get GPT prompts')
    })

export const getGptPrompt = (id) =>
  apiInstance3
    .get(`/backoffice/gpt_prompts/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot get GPT prompt')
    })

export const updateGptPrompt = ({ id, data }) =>
  apiInstance3
    .put(`/backoffice/gpt_prompts/${id}`, data)
    .then((response) => response)
    .catch((error) => {
      parseError(error, 'GPT prompt has not been updated')
      throw error
    })
